import { IOfferForMobileSiteSchema } from '../../repositories/search-engine/entities/offer/OfferForMobileSiteSchema';
import { ITypedReduxAction } from '../../types/redux';

export enum EEmptyListingSuggestionsActionType {
  Request = 'emptyListingSuggestions/request',
  Success = 'emptyListingSuggestions/success',
  Failure = 'emptyListingSuggestions/failure',
}

export type TEmptyListingSuggestionsRequest = ITypedReduxAction<EEmptyListingSuggestionsActionType.Request>;
export type TEmptyListingSuggestionsSuccess = ITypedReduxAction<
  EEmptyListingSuggestionsActionType.Success,
  IOfferForMobileSiteSchema[]
>;
export type TEmptyListingSuggestionsFailure = ITypedReduxAction<EEmptyListingSuggestionsActionType.Failure>;

export type TEmptyListingSuggestionsActions =
  | TEmptyListingSuggestionsRequest
  | TEmptyListingSuggestionsSuccess
  | TEmptyListingSuggestionsFailure;
